module.exports = __webpack_public_path__ + "img/csr_110923_G.52c1d1f3.jpg";